// extracted by mini-css-extract-plugin
module.exports = {"siteTabs":"site-switch-tab_siteTabs__abhPb"};